
import { useEffect } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { WorkSubTypeDDLAPI } from '../../Redux/DDLSlice'
import { AstricSign } from '../../Helper/AstricSign'

export const WorkSubTypeDDL = (props) => {
    const { WorkSubType, setWorkSubType, Flag, rowData, WorkType, M_ProjectTypeID, WorkName, IsDisabled } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_WorkTypeID: WorkType.ID,
            M_UserID: UserID,
            token: token
        }
        dispatch(WorkSubTypeDDLAPI({ data }))
    }, [WorkType.ID])

    const { WorkSubTypeData } = useSelector(state => state.WorkSubTypeDDLData)

    useEffect(() => {
        handleWorkSubTypeDDL()
    }, [WorkSubTypeData])


    const handleWorkSubTypeDDL = () => {
        // console.log(DeptDDLDataa)
        if (WorkSubTypeData && WorkSubTypeData.table && WorkSubTypeData.table.length > 0) {
            let list = WorkSubTypeData.table.map((item, index) => ({
                value: item.m_WorkSubTypeID,
                label: item.workSubTypeName,
            }))
            if (M_ProjectTypeID != 8) {
                if (rowData && WorkType.ID != rowData.m_WorkTypeID) {
                    setWorkSubType({
                        ...WorkSubType,
                        ID: 0,
                        Label: "Select...",
                    })
                } else {

                    setWorkSubType({
                        DDL: list,
                        ID: Flag === 'Update' ? rowData.m_WorkSubTypeID : 0,
                        Label: Flag === 'Update' ? rowData.workSubTypeName : "Select...",
                    })
                }
            } else {
                setWorkSubType({
                    DDL: list,
                    ID: Flag === 'Update' ? rowData.m_eleC_WorkSubTypeID : 0,
                    Label: Flag === 'Update' ? rowData.workSubTypeName : "Select...",
                })
            }
        }
        else {
            setWorkSubType({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label for=""><b>Work Sub Type {Flag && <AstricSign />} </b></label>

            <Select
                isClearable
                // isRtl={isRtl}
                isDisabled={Flag === 'Update' && IsDisabled ? true : false}
                isSearchable
                maxMenuHeight={115}
                value={{ value: WorkSubType.ID, label: WorkSubType.Label }}
                onChange={(e) => {
                    e ?
                        setWorkSubType({ ...WorkSubType, ID: e.value, Label: e.label })
                        :
                        setWorkSubType({ ...WorkSubType, ID: 0, Label: "Select..." })

                }}
                options={WorkSubType.DDL}
            />
        </div>
    )
}